/* GORSKI: after a variant change, select the variant's photo by its place among the visible slides.
   Runs after Prestige's own handler (the event bubbles to document). */
document.addEventListener('variant:change', function (event) {
  var detail = event.detail || {};
  var variant = detail.variant;
  if (!variant || !variant.featured_media) return;
  if (detail.previousVariant && detail.previousVariant.featured_media && detail.previousVariant.featured_media.id === variant.featured_media.id) return;
  document.querySelectorAll('product-gallery[form="' + detail.formId + '"]').forEach(function (gallery) {
    var carousel = gallery.carousel;
    var media = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
    if (!carousel || !media || !carousel.cells) return;
    var index = carousel.cells.indexOf(media);
    if (index >= 0 && index !== carousel.selectedIndex) carousel.select(index, { instant: true });
  });
});
